import { createStore } from '@tanstack/react-store'

interface BeforeInstallPromptEvent extends Event {
	prompt(): Promise<{ outcome: 'accepted' | 'dismissed' }>
}

declare global {
	interface WindowEventMap {
		beforeinstallprompt: BeforeInstallPromptEvent
	}
}

export const PWAInstallStore = createStore<BeforeInstallPromptEvent | null>(null)

export function initializePWAInstall() {
	const standalone = window.matchMedia('(display-mode: standalone)')
	const clearPrompt = () => PWAInstallStore.setState(() => null)
	const handleBeforeInstallPrompt = (event: BeforeInstallPromptEvent) => {
		if (standalone.matches) return

		event.preventDefault()
		PWAInstallStore.setState(() => event)
	}
	const handleDisplayModeChange = () => {
		if (standalone.matches) clearPrompt()
	}

	window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
	window.addEventListener('appinstalled', clearPrompt)
	standalone.addEventListener('change', handleDisplayModeChange)

	return () => {
		window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
		window.removeEventListener('appinstalled', clearPrompt)
		standalone.removeEventListener('change', handleDisplayModeChange)
		clearPrompt()
	}
}
